import ArrowDownIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import ArrowUpIcon from "@mui/icons-material/KeyboardArrowUpRounded";
import { Divider, Drawer, IconButton, Stack, Typography } from "@mui/material";
import CloseIconButton from "@entrilia/shared/components/CloseIconButton";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill";
import type { ChecklistTask } from "../../../api/types/objectTypes";
import ObjectTaskDetailsEditForm from "./ObjectTaskDetailsEditForm";
import ObjectTaskDetailsInfoSection from "./ObjectTaskDetailsInfoSection";
import ObjectTasksActions from "./ObjectTasksActions";

interface Props {
  task: ChecklistTask;
  navigationDisabled?: boolean;
  onNavigate: (direction: 1 | -1) => void;
  onClose: () => void;
}

const ObjectTaskDetailsDrawer = ({ task, navigationDisabled, onNavigate, onClose }: Props) => {
  return (
    <Drawer anchor="right" open onClose={onClose} sx={{ "& .MuiDrawer-paper": { width: "40rem" } }}>
      <Stack direction="row" spacing={1} sx={{ alignItems: "center", px: 2, py: 1 }}>
        <IconButton aria-label="previous task" onClick={() => onNavigate(-1)} disabled={navigationDisabled}>
          <ArrowUpIcon />
        </IconButton>
        <IconButton aria-label="next task" onClick={() => onNavigate(1)} disabled={navigationDisabled}>
          <ArrowDownIcon />
        </IconButton>
        <ObjectTasksActions row={task} />
        <HorizontalFill />
        <CloseIconButton color="secondary" onClick={onClose} />
      </Stack>
      <Divider />
      <Stack spacing={3} sx={{ py: 4, px: 3, overflow: "auto", flexGrow: 1 }}>
        <Stack spacing={0.5}>
          <Typography variant="h5">{task.name}</Typography>
          <Typography variant="caption" color="textSecondary">
            {task.category ?? "(No Category)"}
          </Typography>
        </Stack>

        <ObjectTaskDetailsInfoSection task={task} />

        <Divider />

        <ObjectTaskDetailsEditForm key={task.id} task={task} />
      </Stack>
    </Drawer>
  );
};

export default ObjectTaskDetailsDrawer;
